/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function Linux() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'Linux',
				config: {
					ruleType: "os",
					args: {
						os: ["linux"],
					},
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			Linux
			operating
			systems.
		</p>
	</>;
}
